import Button from "../Button/Button";
import Heading from "../Heading/Heading";

// Define types for carousel container props
interface CarouselContainerProps {
    className: string;
    title: string;
    content: string;
    backgroundColor?: string;
}

const CarouselContainer: React.FC<CarouselContainerProps> = ({
    className = '',
    title = '',
    content = '',
    backgroundColor = '#14161B'
}) => {
    return (
        <div className={className} style={{
            width: '300px',
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'flex-start'
        }}>
            <div style={{ backgroundColor: backgroundColor, height: '200px', width: '300px', marginBottom: '15px', borderRadius: '4px' }} />
            <Heading size="h6" type="secondary" theme="dark">{title}</Heading>
            <Heading size="h6" type="primary" theme="dark">{content}</Heading>
            <Button type="primary" theme='dark'>Read More</Button>
        </div>
    );
};

export default CarouselContainer;

